export default {"src":"/_next/static/media/FSLR.a8e658a4.svg","height":18,"width":18};